import React from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { ChevronDown } from "lucide-react";

const nomeNeg = (n) => n?.name || n?.nome || n?.id;
const multi = (v) => ["responsabile", "area_manager"].includes(v.venditore_level);

// Assegna il venditore al negozio direttamente dalla riga (salva subito)
export default function NegozioPicker({ v, negozi, onSaved }) {
  const save = async (patch, msg) => {
    try { await api.put(`/users/${v.id}`, patch); toast.success(msg); onSaved(); }
    catch (e) { toast.error(e.response?.data?.detail || "Salvataggio non riuscito"); }
  };
  if (!multi(v)) return (
    <select value={negozi.some((n) => n.id === v.negozio_id) ? v.negozio_id : ""} onChange={(e) => save({ negozio_id: e.target.value || null }, "Negozio assegnato")}
      className="h-8 text-xs border border-zinc-300 rounded px-1 bg-white max-w-[180px]" data-testid={`vend-negozio-${v.id}`}>
      <option value="">— nessun negozio —</option>
      {negozi.map((n) => <option key={n.id} value={n.id}>{nomeNeg(n)}</option>)}
    </select>
  );
  const ids = (v.negozi_ids || []).filter((id) => negozi.some((n) => n.id === id));
  const toggle = (id) => save({ negozi_ids: ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id] }, "Negozi aggiornati");
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="h-8 text-xs border border-zinc-300 rounded px-2 bg-white inline-flex items-center gap-1" data-testid={`vend-negozi-${v.id}`}>
          {ids.length ? ids.map((id) => nomeNeg(negozi.find((n) => n.id === id))).join(", ") : "— nessun negozio —"}<ChevronDown className="h-3 w-3" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-60 p-2">
        {negozi.map((n) => (
          <label key={n.id} className="flex items-center gap-2 text-sm p-1 hover:bg-zinc-50 rounded cursor-pointer">
            <input type="checkbox" checked={ids.includes(n.id)} onChange={() => toggle(n.id)} className="accent-emerald-600" data-testid={`vend-negozi-chk-${v.id}-${n.id}`} />{nomeNeg(n)}
          </label>
        ))}
      </PopoverContent>
    </Popover>
  );
}
